import { defaultPageTitle } from "../../../configuration";

const revertTitle = () => {
  setTimeout(() => {
    document.title = defaultPageTitle;
  }, 1000);
};

export default revertTitle;
